function aiwaDebugSticky(msg, data){
  console.log("[AIWA STICKY]", msg, data || "");
}
/* =========================================================
   AIWA TAGBAR — CORE ENGINE
========================================================= */

// console.log("[AIWA] Tagbar engine loaded");

/* ---------------------------------------
   HANDLEIZE
--------------------------------------- */

function aiwaHandleize(str){

  return (str || "")
    .toString()
    .trim()
    .toLowerCase()
    .replace(/['"]/g,"")
    .replace(/[^a-z0-9]+/g,"-")
    .replace(/-+/g,"-")
    .replace(/^-|-$/g,"");

}

/* ---------------------------------------
   CENTER ACTIVE TAG
--------------------------------------- */

function aiwaCenterActiveTag(tag){

  if(!tag) return;

  const container = tag.closest(".aiwa-tagbar");
  if(!container) return;

  const containerRect = container.getBoundingClientRect();
  const tagRect = tag.getBoundingClientRect();

  const offset =
    tagRect.left -
    containerRect.left -
    (containerRect.width / 2) +
    (tagRect.width / 2);

  container.scrollBy({
    left: offset,
    behavior: "smooth"
  });

}

/* ---------------------------------------
   SET ACTIVE TAG
--------------------------------------- */

function aiwaSetActiveTag(tagbarWrap, tagHandle){

  const buttons = tagbarWrap.querySelectorAll(".aiwa-tagbar__item");

  buttons.forEach(btn => {

    const tag = btn.dataset.tag || "";
    const handle = aiwaHandleize(tag);

    btn.classList.toggle("is-active", handle === tagHandle);

  });

  const activeBtn = tagbarWrap.querySelector(".aiwa-tagbar__item.is-active");

  aiwaCenterActiveTag(activeBtn);

}

/* ---------------------------------------
   TAG CLICK
--------------------------------------- */

document.addEventListener("click", function(e){

  const btn = e.target.closest(".aiwa-tagbar__item");
  if(!btn) return;

  const wrap = btn.closest("[data-aiwa-tagbar]");
  if(!wrap) return;

  const collectionBase = wrap.dataset.collectionUrl;

  const tag = btn.dataset.tag || "";
  const handle = aiwaHandleize(tag);

  const nextUrl = handle
    ? `${collectionBase}/${handle}`
    : `${collectionBase}`;

  aiwaSetActiveTag(wrap, handle);

window.history.pushState(
  {tag: handle},
  "",
  nextUrl
);

aiwaResetInfiniteScrollState();
aiwaLoadCollectionSection(nextUrl);

});

/* ---------------------------------------
   PAGE LOAD SYNC
--------------------------------------- */

document.addEventListener("DOMContentLoaded", function(){

  const pathParts = window.location.pathname.split("/");
  const currentTag = pathParts[pathParts.length - 1];

  document.querySelectorAll("[data-aiwa-tagbar]").forEach(tagbar => {

    aiwaSetActiveTag(tagbar, currentTag);

  });

});
/* =========================================================
   AIWA AJAX — LOAD COLLECTION GRID
========================================================= */

async function aiwaLoadCollectionSection(url){

  const section = document.querySelector("#CollectionAI");
  if(!section) return;

  const SECTION_ID = section.dataset.sectionId;
  if(!SECTION_ID) return;

  try{

    const fetchUrl = url + (url.includes("?") ? "&" : "?") + "sections=" + SECTION_ID;

    const res = await fetch(fetchUrl,{
      credentials:"same-origin"
    });

    if(!res.ok) throw new Error("Fetch failed");

    const data = await res.json();

    const html = data[SECTION_ID];
    if(!html) throw new Error("Section missing");

    const temp = document.createElement("div");
    temp.innerHTML = html;

    const newGrid = temp.querySelector("#CollectionAIProductGrid");
    const currentGrid = document.querySelector("#CollectionAIProductGrid");

if(newGrid && currentGrid){
  currentGrid.innerHTML = newGrid.innerHTML;
}

aiwaSyncFiltersFromUrl();
aiwaRenderInlineChips();
aiwaUpdateFilterButtonCount();

const trust = document.querySelector('#aiwa-trust-section');
const grid = document.querySelector('#CollectionAIProductGrid');
const pinnedBar = document.querySelector('.aiwa-filter-trigger-wrap');

const pinnedOffset = pinnedBar ? pinnedBar.offsetHeight + 12 : 12;
const anchor = trust || grid;

if(anchor){
  const y = anchor.getBoundingClientRect().top + window.scrollY - pinnedOffset;
  window.scrollTo({ top: y, behavior: 'smooth' });
}

/* update pagination separately */

const newPagination = temp.querySelector("#CollectionAIPagination");
const currentPagination = document.querySelector("#CollectionAIPagination");

if(newPagination && currentPagination){
  currentPagination.innerHTML = newPagination.innerHTML;
}
  }

  catch(e){

    console.warn("[AIWA] AJAX failed → fallback navigation");

    window.location.href = url;

  }

}
/* =========================================================
   AIWA FILTER PANEL — CORE ENGINE
========================================================= */

(function(){

  const panel   = document.querySelector('[data-aiwa-filter-panel]');
  const overlay = document.querySelector('[data-aiwa-filter-overlay]');

  if(!panel || !overlay) return;

  function openFilters(){

    panel.classList.add("is-open");
    overlay.classList.add("is-open");
    document.body.classList.add("aiwa-filter-open");

  }

  function closeFilters(){

    panel.classList.remove("is-open");
    overlay.classList.remove("is-open");
    document.body.classList.remove("aiwa-filter-open");

  }

  document.addEventListener("click", function(e){

    if(e.target.closest("[data-aiwa-filter-open]")){
      openFilters();
    }

    if(e.target.closest("[data-aiwa-filter-close]")){
      closeFilters();
    }

    if(e.target.closest("[data-aiwa-filter-overlay]")){
      closeFilters();
    }

  });

  document.addEventListener("keydown", function(e){

    if(e.key === "Escape"){
      closeFilters();
    }

  });

})();

/* =========================================================
   AIWA HISTORY — BACK / FORWARD SUPPORT
========================================================= */

window.addEventListener("popstate", function(){

  const pathParts = window.location.pathname.split("/");
  const currentTag = pathParts[pathParts.length - 1];

  document.querySelectorAll("[data-aiwa-tagbar]").forEach(tagbar => {
    aiwaSetActiveTag(tagbar, currentTag);
  });

  aiwaResetInfiniteScrollState();
aiwaLoadCollectionSection(window.location.pathname + window.location.search);
aiwaSyncFiltersFromUrl();
aiwaRenderInlineChips();
aiwaUpdateFilterButtonCount();

});

/* =========================================================
   AIWA FILTER BUTTON — TRIGGER
========================================================= */

function aiwaTriggerFilterButton(){

  const btn = document.querySelector('[data-aiwa-filter-open]');
  if(!btn) return;

  btn.addEventListener("click", function(){
    document.dispatchEvent(
      new CustomEvent("aiwa:filter-open")
    );
  });

}
/* =========================================================
   AIWA FILTER — CHANGE DETECTOR
========================================================= */

document.addEventListener("change", function(e){

  const panel = e.target.closest('[data-aiwa-filter-panel]');
  if(!panel) return;

  // console.log("[AIWA FILTER] changed", e.target.name, e.target.value);

});
/* =========================================================
   AIWA — GET ACTIVE TAG HANDLE
========================================================= */

function aiwaGetActiveTagHandle(){

  const customChecked = document.querySelectorAll('[data-aiwa-custom-tag]:checked');

  if(customChecked.length){
    return Array.from(customChecked)
      .map(input => aiwaHandleize(input.getAttribute('data-aiwa-custom-tag') || ""))
      .filter(Boolean)
      .join('+');
  }

  const active = document.querySelector(".aiwa-tagbar__item.is-active");
  if(!active) return "";

  const tag = active.dataset.tag || "";

  return aiwaHandleize(tag);

}
/* =========================================================
   AIWA — BUILD FILTER URL (ALL COLLECTIONS SAFE)
========================================================= */

function aiwaBuildFilterUrl(){

  const grid = document.querySelector("#CollectionAI");
  if(!grid) return "";

  const SECTION_ID = grid.getAttribute("data-section-id");

  const wrap = document.querySelector("[data-aiwa-tagbar]");

  // Collection base fallback
  let collectionBase;

  if(wrap){
    collectionBase = wrap.dataset.collectionUrl;
  } else {
    // Works for ALL collections
    collectionBase = window.location.pathname.split("/").slice(0,3).join("/");
  }

const tagHandle = aiwaGetActiveTagHandle();

  const basePath = tagHandle
    ? `${collectionBase}/${tagHandle}`
    : `${collectionBase}`;

  const params = new URLSearchParams();

  const inputs = document.querySelectorAll(
    '[data-aiwa-filter-panel] input, [data-aiwa-filter-panel] select'
  );

inputs.forEach(input => {

  if(input.hasAttribute('data-aiwa-custom-tag')){
    return;
  }

  if((input.type === "checkbox" || input.type === "radio") && input.checked){
    params.append(input.name, input.value);
  }

  if(input.type === "number" && input.value){
    params.set(input.name, input.value);
  }

  if(input.tagName === "SELECT" && input.value){
    params.set(input.name, input.value);
  }

});

  if(SECTION_ID){
    params.set("sections", SECTION_ID);
  }

  const query = params.toString();

  return query
    ? `${basePath}?${query}`
    : basePath;

}
/* =========================================================
   AIWA FILTER — CHANGE WATCHER
========================================================= */

document.addEventListener("change", function(e){

  const panel = e.target.closest("[data-aiwa-filter-panel]");
  if(!panel) return;

  const url = aiwaBuildFilterUrl();
  if(!url) return;

  aiwaResetInfiniteScrollState();
  aiwaLoadCollectionSection(url);

  window.history.pushState({}, "", url.replace(/(\?|&)sections=[^&]*/, ""));

  aiwaRenderInlineChips();
  aiwaUpdateFilterButtonCount();

});
/* =========================================================
   AIWA FILTER — APPLY BUTTON
========================================================= */

document.addEventListener("click", function(e){

  const btn = e.target.closest(".aiwa-apply");
  if(!btn) return;

  const url = aiwaBuildFilterUrl();
  if(!url) return;

  aiwaResetInfiniteScrollState();
  aiwaLoadCollectionSection(url);

  window.history.pushState({}, "", url.replace(/(\?|&)sections=[^&]*/, ""));

  /* CLOSE FILTER PANEL */

  const panel   = document.querySelector('[data-aiwa-filter-panel]');
  const overlay = document.querySelector('[data-aiwa-filter-overlay]');

  panel?.classList.remove("is-open");
  overlay?.classList.remove("is-open");
  document.body.classList.remove("aiwa-filter-open");

});

/* =========================================================
   AIWA PAGINATION — KEEP FILTERS
========================================================= */

document.addEventListener("click", function(e){

  const link = e.target.closest('[href*="page="]');
  if(!link) return;

  e.preventDefault();

  const pageLink = link.getAttribute("href");

  const currentSearch = window.location.search;

  const page = new URLSearchParams(pageLink.split("?")[1]).get("page");

  const cleanSearch = currentSearch.replace(/page=\d+/,"").replace(/\?$/,"");

  const mergedUrl =
    window.location.pathname +
    (cleanSearch ? cleanSearch + "&" : "?") +
    "page=" + page;

    aiwaResetInfiniteScrollState();
  aiwaLoadCollectionSection(mergedUrl);

  window.history.pushState({}, "", mergedUrl);

});

/* =========================================================
   AIWA RESET BUTTON - FUNCTIONALITY   
========================================================= */

document.addEventListener("click", function(e){

  if(!e.target.closest("[data-ai-filter-clear]")) return;

  e.preventDefault();

  document.querySelector('[data-aiwa-filter-close]')?.click();

  document.querySelector('[data-ai-filter-form]')?.reset();

  history.replaceState({}, '', window.location.pathname);

aiwaRenderInlineChips();
aiwaUpdateFilterButtonCount();

aiwaResetInfiniteScrollState();
aiwaLoadCollectionSection(window.location.pathname);

});
/* =========================================================
   AIWA INFINITE SCROLL (FULLY INTEGRATED)
========================================================= */

let aiwaLoading = false;
let aiwaInfinitePage = null;
let aiwaHasMorePages = true;

function aiwaResetInfiniteScrollState(){
  const params = new URLSearchParams(window.location.search);
  aiwaInfinitePage = parseInt(params.get("page") || "1", 10);
  aiwaHasMorePages = true;
  aiwaLoading = false;
}

window.addEventListener("scroll", async function(){

  if(aiwaLoading || !aiwaHasMorePages) return;

  const gridWrap = document.querySelector("#CollectionAIProductGrid");
  const grid = document.querySelector("#CollectionAIProductGrid .product-grid");

  if(!grid || !gridWrap) return;

  /* trigger near end of product grid */
  const rect = gridWrap.getBoundingClientRect();

  if(rect.bottom > window.innerHeight + 600) return;

  if(aiwaInfinitePage === null){
    aiwaResetInfiniteScrollState();
  }

  const nextPage = aiwaInfinitePage + 1;

  const params = new URLSearchParams(window.location.search);
  params.set("page", nextPage);

  const nextUrl = window.location.pathname + "?" + params.toString();

  aiwaLoading = true;

  try{

    const section = document.querySelector("#CollectionAI");
    if(!section) throw new Error("Missing collection section");

    const SECTION_ID = section.dataset.sectionId;
    if(!SECTION_ID) throw new Error("Missing section id");

    const fetchUrl = nextUrl + "&sections=" + SECTION_ID;

    const res = await fetch(fetchUrl,{
      credentials:"same-origin"
    });

    if(!res.ok) throw new Error("Fetch failed");

    const data = await res.json();
    const html = data[SECTION_ID];
    if(!html) throw new Error("Section missing");

    const temp = document.createElement("div");
    temp.innerHTML = html;

    const newProducts =
      temp.querySelectorAll("#CollectionAIProductGrid .product-grid > li");

    if(!newProducts.length){
      aiwaHasMorePages = false;
      return;
    }

    newProducts.forEach(el => grid.appendChild(el));

    aiwaInfinitePage = nextPage;

    /* update pagination block */
    const newPagination = temp.querySelector("#CollectionAIPagination");
    const currentPagination = document.querySelector("#CollectionAIPagination");

    if(newPagination && currentPagination){
      currentPagination.innerHTML = newPagination.innerHTML;
    }

  }

  catch(e){

    console.warn("[AIWA] Infinite scroll failed", e);

  }

  aiwaLoading = false;

});
/* =========================================================
   AIWA TRUST ICONS
========================================================= */

(function(){

const TRUST_ID = "aiwa-trust-section";

function initTrustSection(){

if(document.getElementById(TRUST_ID)) return;

/* icons */

const icons = [

{
text:"Video Approval Before Delivery",
icon:"https://cdn.shopify.com/s/files/1/0557/5750/4548/files/aiwa-flowers-video-approval-before-delivery-aiwa-icon.svg?v=1774056798"
},

{
text:"Fresh Flower Guarantee",
icon:"https://cdn.shopify.com/s/files/1/0557/5750/4548/files/aiwa-flowers-fresh-flower-guarantee-aiwa-icon.svg?v=1774056589"
},

{
text:"Same-Day Delivery",
icon:"https://cdn.shopify.com/s/files/1/0557/5750/4548/files/aiwa-flowers-same-day-delivery-aiwa-icon.svg?v=1774056767"
},


];

/* detect anchor */

function findAnchor(){

const tagbar = document.querySelector(".aiwa-tagbar-wrap");
if(tagbar) return tagbar;

const filterTrigger = document.querySelector(".aiwa-filter-trigger-wrap");
if(filterTrigger) return filterTrigger;

const grid = document.querySelector("#CollectionAIProductGrid");
if(grid) return grid;

return null;

}

const anchor = findAnchor();
if(!anchor) return;

/* create section */

const section = document.createElement("section");

section.id = TRUST_ID;

section.innerHTML = `
<div class="aiwa-trust-inner">

${icons.map(icon => `

<div class="aiwa-trust-item">

<img src="${icon.icon}" alt="">

<span>${icon.text}</span>

</div>

`).join("")}

</div>
`;

/* insert */

if(anchor.id === "CollectionAIProductGrid"){
anchor.parentNode.insertBefore(section,anchor);
}
else{
anchor.insertAdjacentElement("afterend",section);
}

}

/* initial load */

document.addEventListener("DOMContentLoaded", initTrustSection);

/* run again after ajax grid reload */

const observer = new MutationObserver(initTrustSection);

observer.observe(document.body,{
childList:true,
subtree:true
});

})();


/* =========================================================
   AIWA TRUST BAR — POSITION FIRST
========================================================= */

(function(){

  function aiwaPositionTrustFirst(){

    const trust = document.querySelector("#aiwa-trust-section");
    if(!trust) return;

    const tagbar = document.querySelector(".aiwa-tagbar-wrap");
    const filter = document.querySelector(".aiwa-filter-trigger-wrap");
    const grid = document.querySelector("#CollectionAIProductGrid");

    let anchor = null;

    if(tagbar){
      anchor = tagbar;
    }
    else if(filter){
      anchor = filter;
    }
    else if(grid){
      anchor = grid;
    }

    if(!anchor) return;

    if(trust.nextElementSibling === anchor) return;

    anchor.parentNode.insertBefore(trust, anchor);
  }

  document.addEventListener("DOMContentLoaded", aiwaPositionTrustFirst);

  const observer = new MutationObserver(aiwaPositionTrustFirst);
  observer.observe(document.body,{
    childList:true,
    subtree:true
  });

})();

function aiwaSyncFiltersFromUrl(){

  const path = window.location.pathname;
  const search = new URLSearchParams(window.location.search);

  /* -----------------------------------
     1) RESET KNOWN UI STATE FIRST
  ----------------------------------- */

  document.querySelectorAll('[data-aiwa-custom-tag]').forEach(input => {
    input.checked = false;
  });

  document.querySelectorAll('input[name="sort_by"]').forEach(input => {
    input.checked = false;
  });

  const minInput = document.querySelector('input[name="filter.v.price.gte"]');
  const maxInput = document.querySelector('input[name="filter.v.price.lte"]');

  if(minInput) minInput.value = "";
  if(maxInput) maxInput.value = "";

  /* -----------------------------------
     2) SYNC CUSTOM TAGS FROM PATH
  ----------------------------------- */

  const pathParts = path.split("/").filter(Boolean);
  const lastPart = pathParts[pathParts.length - 1] || "";

  if(path.includes("/collections/") && lastPart){
    const tagHandles = lastPart.split("+").map(v => v.trim()).filter(Boolean);

    document.querySelectorAll('[data-aiwa-custom-tag]').forEach(input => {
      const tag = input.getAttribute("data-aiwa-custom-tag") || "";
      const handle = aiwaHandleize(tag);
      input.checked = tagHandles.includes(handle);
    });
  }

  /* -----------------------------------
     3) SYNC SORT FROM QUERY
  ----------------------------------- */

  const sortValue = search.get("sort_by") || "";

  document.querySelectorAll('input[name="sort_by"]').forEach(input => {
    input.checked = input.value === sortValue;
  });

  /* -----------------------------------
     4) SYNC PRICE FROM QUERY
  ----------------------------------- */

  const minVal = search.get("filter.v.price.gte") || "";
  const maxVal = search.get("filter.v.price.lte") || "";

  if(minInput) minInput.value = minVal;
  if(maxInput) maxInput.value = maxVal;

}

function aiwaRenderInlineChips(){

  const container = document.getElementById("AiwaInlineFilterChips");
  if(!container) return;

  const items = [];

  /* custom tag filters */
  document.querySelectorAll('[data-aiwa-custom-tag]:checked').forEach(input => {
    const value = input.getAttribute("data-aiwa-custom-tag");
    if(value){
      items.push({
        label: value,
        type: "custom-tag",
        value: value
      });
    }
  });

  /* sort by */
  const activeSort = document.querySelector('input[name="sort_by"]:checked');
  if(activeSort){
    const labelText = activeSort.closest("label")?.textContent.trim();
    if(labelText){
      items.push({
        label: labelText,
        type: "sort",
        value: activeSort.value
      });
    }
  }

  /* price range */
  const minInput = document.querySelector('input[name="filter.v.price.gte"]');
  const maxInput = document.querySelector('input[name="filter.v.price.lte"]');

  const minVal = minInput?.value?.trim() || "";
  const maxVal = maxInput?.value?.trim() || "";

  if(minVal || maxVal){
    let priceLabel = "";

    if(minVal && maxVal){
      priceLabel = `${minVal}–${maxVal} AED`;
    } else if(minVal){
      priceLabel = `From ${minVal} AED`;
    } else if(maxVal){
      priceLabel = `Up to ${maxVal} AED`;
    }

    items.push({
      label: priceLabel,
      type: "price",
      value: "price"
    });
  }

  if(!items.length){
    container.innerHTML = "";
    container.hidden = true;
    return;
  }

  container.hidden = false;

  const maxVisible = 3;
  const visible = items.slice(0, maxVisible);
  const remaining = items.length - maxVisible;

  container.innerHTML =
    visible.map(item => `
      <div class="aiwa-filter-inline-chip">
        ${item.label}
        <button
          type="button"
          data-remove-chip="${item.value}"
          data-remove-chip-type="${item.type}"
        >×</button>
      </div>
    `).join("") +
    (remaining > 0
      ? `<div class="aiwa-filter-inline-chip">+${remaining} more</div>`
      : "");

}

function aiwaUpdateFilterButtonCount(){

  const btn = document.querySelector('.aiwa-filter-trigger');
  if(!btn) return;

  const customTags = document.querySelectorAll('[data-aiwa-custom-tag]:checked').length;
  const sort = document.querySelector('input[name="sort_by"]:checked') ? 1 : 0;

  const min = document.querySelector('input[name="filter.v.price.gte"]')?.value?.trim();
  const max = document.querySelector('input[name="filter.v.price.lte"]')?.value?.trim();
  const price = (min || max) ? 1 : 0;

  const total = customTags + sort + price;

  btn.textContent = total > 0 ? `Filters (${total})` : 'Filters';

}

document.addEventListener("click", function(e){

  const btn = e.target.closest("[data-remove-chip]");
  if(!btn) return;

  const value = btn.getAttribute("data-remove-chip");
  const type = btn.getAttribute("data-remove-chip-type");

  if(type === "custom-tag"){
    const input = Array.from(document.querySelectorAll('[data-aiwa-custom-tag]'))
      .find(el => el.getAttribute("data-aiwa-custom-tag") === value);

    if(input){
      input.checked = false;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    }
  }

  if(type === "sort"){
    const input = document.querySelector(`input[name="sort_by"][value="${value}"]`);
    if(input){
      input.checked = false;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    }
  }

  if(type === "price"){
    const minInput = document.querySelector('input[name="filter.v.price.gte"]');
    const maxInput = document.querySelector('input[name="filter.v.price.lte"]');

    if(minInput) minInput.value = "";
    if(maxInput) maxInput.value = "";

    if(minInput){
      minInput.dispatchEvent(new Event("change", { bubbles: true }));
    } else if(maxInput){
      maxInput.dispatchEvent(new Event("change", { bubbles: true }));
    }
  }

});
document.addEventListener("DOMContentLoaded", function(){
  aiwaSyncFiltersFromUrl();
  aiwaRenderInlineChips();
  aiwaUpdateFilterButtonCount();
});

/* =========================================================
   AIWA PINNED FILTER BAR — PREMIUM
========================================================= */

(function(){

  const el = document.querySelector('.aiwa-filter-trigger-wrap');
  if(!el) return;

  const originalHeight = el.offsetHeight;

  let placeholder = document.getElementById('aiwa-sticky-placeholder');
  if(!placeholder){
    placeholder = document.createElement('div');
    placeholder.id = 'aiwa-sticky-placeholder';
  }

  let pinned = false;
  let pinStartY = null;

  function pin(){

    const rect = el.getBoundingClientRect();

    placeholder.style.height = originalHeight + 'px';

    if(!placeholder.parentNode){
      el.parentNode.insertBefore(placeholder, el);
    }

    pinStartY = window.scrollY;

    el.classList.add('is-pinned');

el.style.position = 'fixed';
el.style.top = '0px';

if(window.innerWidth <= 768){
  el.style.left = '0px';
  el.style.right = '0px';
  el.style.width = 'auto';
} else {
  el.style.left = rect.left + 'px';
  el.style.right = '';
  el.style.width = rect.width + 'px';
}

    pinned = true;
  }

  function unpin(){

    if(placeholder.parentNode){
      placeholder.remove();
    }

    el.classList.remove('is-pinned');

el.style.position = '';
el.style.top = '';
el.style.left = '';
el.style.right = '';
el.style.width = '';

    pinned = false;
    pinStartY = null;
  }

  function onScroll(){

    if(!pinned){
      const rect = el.getBoundingClientRect();
      if(rect.top <= 0) pin();
    } else {
      if(window.scrollY <= pinStartY) unpin();
    }

  }

function onResize(){
  if(!pinned) return;

  if(window.innerWidth <= 768){
    el.style.left = '0px';
    el.style.right = '0px';
    el.style.width = 'auto';
  } else {
    const placeholderRect = placeholder.getBoundingClientRect();
    el.style.left = placeholderRect.left + 'px';
    el.style.right = '';
    el.style.width = placeholderRect.width + 'px';
  }
}

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onResize);

})();

/* =========================================================
   AIWA SCROLL TO TOP — AJAX SAFE + SMART SAFE VISIBILITY
========================================================= */

(function(){

  function aiwaGetScrollTopBtn(){
    return document.getElementById('aiwa-scroll-top');
  }

  function aiwaHasBlockingLayerOpen(){
    return !!document.querySelector(`
      body.aiwa-filter-open,
      .aiwa-filter-overlay.is-open,
      .aiwa-filter-panel.is-open,
      .menu-drawer[open],
      details[open].menu-drawer-container,
      .drawer.is-open,
      .modal[open],
      .modal.is-open,
      .popup-modal[open],
      .search-modal[open],
      .shopify-section-group-header-group .menu-drawer-container.menu-opening
    `);
  }

  function aiwaUpdateScrollTopVisibility(){
    const btn = aiwaGetScrollTopBtn();
    if(!btn) return;

    const shouldShow = window.scrollY > 500 && !aiwaHasBlockingLayerOpen();

    btn.classList.toggle('is-visible', shouldShow);
    btn.classList.toggle('is-blocked', !shouldShow);
  }

  function aiwaBindScrollTop(){
    const btn = aiwaGetScrollTopBtn();
    if(!btn || btn.dataset.aiwaBound === 'true') return;

    btn.dataset.aiwaBound = 'true';

    btn.addEventListener('click', function(){
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    });
  }

  function aiwaInitScrollTop(){
    aiwaBindScrollTop();
    aiwaUpdateScrollTopVisibility();
  }

  document.addEventListener('DOMContentLoaded', aiwaInitScrollTop);

  window.addEventListener('scroll', aiwaUpdateScrollTopVisibility, { passive: true });
  window.addEventListener('resize', aiwaUpdateScrollTopVisibility);

  document.addEventListener('click', function(){
    requestAnimationFrame(aiwaUpdateScrollTopVisibility);
  });

  document.addEventListener('keydown', function(){
    requestAnimationFrame(aiwaUpdateScrollTopVisibility);
  });

  const aiwaScrollTopObserver = new MutationObserver(function(){
    aiwaInitScrollTop();
  });

  aiwaScrollTopObserver.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'open', 'style']
  });

})();